import os from 'os';
import { BaseFinalCommand } from "namirasoft-node-cli";
import { IStorageMemoryDedicated } from "namirasoft-core";
import { TokenManager } from '../TokenManager';
import { NamirasoftAccountServer } from '../NamirasoftAccountServer';

export class AccountLoginCommand extends BaseFinalCommand
{
    constructor(argv: string[])
    {
        super(argv, ["username", "password"], [
            {
                name: "os",
                short: "",
                description: "Provides the value of 'os' in body",
                optional: true,
                args: ["os"],
                defaults: [os.platform()]
            }]);
    }
    override async exec()
    {
        let storage = new IStorageMemoryDedicated();
        let manager = new TokenManager(storage, () => { });
        let url = this.app.storage.getItem("ns-account-server-url");
        let server = new NamirasoftAccountServer(url, manager, e => this.app.logger.error(e.message));
        let res = await server.session.Login({
            email: this.arg_values[0],
            password: this.arg_values[1],
            os: this.option_values.device_os
        });
        this.app.storage.setNSAToken(res.value);
    }
};